<div class="rounded-circle color-gray-bg white d-flex justify-content-center initials-circle">
  <div class="align-self-center white">
    {{name | initials}}
  </div>
</div>
